// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 642 ? "94a7ad86" : chunkId) + "." + {"642":"332ac891e7a85df0","680":"70086227bfbd901d"}[chunkId] + ".js";
};